const addRUTHyphen = rut => {
    if (rut.includes('-')) return rut
    let lgt = rut.length
    let dv = rut.substr(lgt - 1)
    let rutSinDV = rut.substr(0, lgt - 1)
    return rutSinDV + '-' + dv
}

const removeRUTHyphen = rut => {
    if (!rut.includes('-')) return rut
    const aux = rut.split('-')
    return '' + aux[0] + aux[1]
}

const removeRUTDots = rut => {
    if (!rut.includes('.')) return rut
    const aux = rut.split('.')
    let rutString = ''
    aux.forEach(substr => {
        rutString += substr
    })
    return rutString
}

const addRUTDots = rut => {
    if (rut.includes('.')) return rut
    if (!rut.includes('-')) rut = addRUTHyphen(rut)
    let aux = rut.split('-')
    let dv = aux[1]
    let bd = aux[0]
    bd = bd
        .split('')
        .reverse()
        .join('')
        .match(/.{1,3}/g)
    bd = bd[0] + '.' + bd[1] + '.' + bd[2]
    bd = bd
        .split('')
        .reverse('')
        .join('')
    const rutString = bd + '-' + dv
    return rutString
}

export { addRUTHyphen, removeRUTHyphen, removeRUTDots, addRUTDots }
